export default __webpack_public_path__ + "static/output-204d7e349c014fe36afa9fc6faa441a1.mp4";